import BResourcePage from "../../../components/resources/BResourcePage";

function PartnersPage() {
  return <BResourcePage 
  title={"Kooperationspartner"} url={"/Partners"} />;
}

export default PartnersPage;
